import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  inject,
  OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownInputComponent } from '../../../form-components/dropdown-input/dropdown-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ScreenService } from '../../../../../../services/screen-service.service';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-review-dropdown-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review-dropdown-input.component.html',
  styleUrls: ['./review-dropdown-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReviewDropdownInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewDropdownInputComponent extends DropdownInputComponent implements OnDestroy {
  private screenService = inject(ScreenService);

  private _isMobileSubject = new BehaviorSubject<boolean>(false);
  public override isMobile$ = this._isMobileSubject;

  private _subscription: Subscription;

  constructor(_eref: ElementRef, private _cdr: ChangeDetectorRef) {
    super(_eref, _cdr);
    this._subscription = this.screenService.isMobile$.subscribe(value => this._isMobileSubject.next(value));
  }

  public setDisabledState(isDisabled: boolean): void {
    super.setDisabledState?.(isDisabled);
    this._cdr.markForCheck();
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
    this._isMobileSubject.complete();
  }
}
